<div class="pos-relative">
    <i class="icon-info flex"
       (mouseenter)="toggle(true)"
       (mouseleave)="toggle(false)"
       [ngStyle]="{'fontSize' : fontSize}"></i>
    <div class="_tooltip c1 col-w"
         [ngStyle]="{'width' : containerWidth}"
         [ngClass]="{'_tooltip--display' : display, '_tooltip--right' : isRightDirection}">
        <ng-content></ng-content>
    </div>
</div>